import * as React from "react";
import { ChipIcon, LibraryVariableSetChip } from "~/components/Chips";
import { MissingChip } from "~/components/Chips/index";
import { MultiSelect } from "~/components/MultiSelect/MultiSelect";
import type { FormFieldProps } from "~/components/form";
import type { ComponentProps } from "~/utils/types";
import Lookup from "../Lookup";
interface LibraryVariableSetMultiSelectProps extends FormFieldProps<string[]> {
    items: {
        Id: string;
        Name: string;
    }[];
    autoFocus?: boolean;
    label?: string | JSX.Element;
    error?: string;
    accessibleName?: string;
}
const LibraryVariableSetTypedMultiSelect = MultiSelect<{
    Id: string;
    Name: string;
}>();
type RenderChip = ComponentProps<typeof LibraryVariableSetTypedMultiSelect>["renderChip"];
export const LibraryVariableSetMultiSelect: React.FC<LibraryVariableSetMultiSelectProps> = (props) => {
    const chipRenderer: RenderChip = (r, onRequestDelete: () => void) => {
        return (<Lookup lookupCollection={props.items} lookupId={r.Id} getIdFromElement={(element) => element.Id} render={(item) => <LibraryVariableSetChip libraryVariableSetName={item.Name} onRequestDelete={onRequestDelete} deleteButtonAccessibleName={`Delete ${item.Name}`}/>} renderFallback={<MissingChip type={ChipIcon.LibraryVariableSet} lookupId={r.Id} deleteButtonAccessibleName={"Delete Missing Resource"} onRequestDelete={onRequestDelete}/>}/>);
    };
    return <LibraryVariableSetTypedMultiSelect fieldName="library variable sets" renderChip={chipRenderer} accessibleName={props.accessibleName} {...props} items={props.items}/>;
};
LibraryVariableSetMultiSelect.displayName = "LibraryVariableSetMultiSelect"
